import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { JQLEditor } from '@atlassianlabs/jql-editor';
import { JQLEditorForgeUI } from './ui';
export var JQLEditorForge = function JQLEditorForge(props) {
  return /*#__PURE__*/React.createElement(JQLEditorForgeUI, _extends({}, props, {
    JQLEditor: JQLEditor
  }));
};